import { Flex, Text, Tooltip } from "@fluentui/react-northstar";
import { SurveyDTO } from "@teams/types/api";
import React from "react";

import { SurveyMenu } from "../../SurveyTeamTab/ChannelSurveys/SurveyMenu";
import { SurveyMeetingStatePill } from "./SurveyMeetingStatePill";
import { SurveyTypePill } from "./SurveyTypePill";

export const SurveyInfoBar: React.FC<{
  survey: SurveyDTO;
  isSideBar?: boolean;
  onChanged: () => void;
  hasUserResponded?: boolean;
}> = ({ survey, isSideBar, onChanged, hasUserResponded }) => {
  const hideTemplateSave =
    isSideBar ||
    survey.type === "trivia" ||
    survey.type === "qna" ||
    survey.type === "icebreaker" ||
    survey.type === "hot-take";

  return (
    <>
      <Flex column gap="gap.smaller">
        <Flex gap="gap.smaller" vAlign="center">
          <Flex.Item grow>
            <Flex gap="gap.smaller" vAlign="center">
              <SurveyTypePill survey={survey} />
              <SurveyMeetingStatePill survey={survey} />
            </Flex>
          </Flex.Item>

          {(survey.role === "own" ||
            (hasUserResponded && ["survey", "poll"].includes(survey.type))) && (
            <Flex.Item push>
              <div>
                <SurveyMenu
                  survey={survey}
                  onChanged={onChanged}
                  hideClose={isSideBar}
                  hideOwners={isSideBar}
                  hideTemplateSave={hideTemplateSave}
                  noExposedItems={true}
                  showEditResponses={
                    isSideBar && ["survey", "poll"].includes(survey.type) && hasUserResponded
                  }
                />
              </div>
            </Flex.Item>
          )}
        </Flex>

        <Flex gap="gap.smaller" vAlign="center" hAlign="start">
          {survey.anonymity === "anonymous" && (
            <div>
              <Tooltip
                content="Results are anonymous"
                trigger={
                  <Text
                    content="🔒 Anonymous"
                    weight="light"
                    size="small"
                    style={{ whiteSpace: "nowrap" }}
                  />
                }
              />
            </div>
          )}

          {survey.anonymity === "anonymous" && survey.resultsVisibility === "private" && (
            <Text content="|" weight="light" size="small" />
          )}

          {survey.resultsVisibility === "private" && (
            <div>
              <Tooltip
                content="Results are only available to the sender"
                trigger={
                  <Text
                    content="📊 Private"
                    weight="light"
                    size="small"
                    style={{ whiteSpace: "nowrap" }}
                  />
                }
              />
            </div>
          )}
        </Flex>
      </Flex>
    </>
  );
};
